/**
 * モーダルプラグイン modaalの設定
 * https://github.com/humaan/Modaal
 */

$(document).ready(function () {

});

$('.gallery__modal').modaal({
    type: 'image'
});

/**
 * Modaal用 ギャラリー自動適用スクリプト
 */
document.addEventListener('DOMContentLoaded', function() {
    // 対象とするギャラリーコンテナを選択
    // ページ内に複数のギャラリーがある場合も想定してループ処理します
    const galleryContainers = document.querySelectorAll('.wp-block-gallery');

    if (galleryContainers.length > 0) {
        galleryContainers.forEach((container, galleryIndex) => {

            // ギャラリー内のすべての画像コンテナ (.wp-block-image) を取得
            const imageFigures = container.querySelectorAll('.wp-block-image');

            // ギャラリーごとにユニークなグループ名を作成 (例: gallery-0, gallery-1...)
            const groupName = 'gallery-' + galleryIndex;

            imageFigures.forEach((figure) => {
                const img = figure.querySelector('img');

                if (img) {
                    // 1. フルサイズ画像のURLを取得 (srcsetから最大サイズを取得)
                    let fullSizeUrl = img.src; // 初期値
                    const srcset = img.getAttribute('srcset');

                    if (srcset) {
                        // srcsetを解析して一番最後の（最も大きい）画像のURLを取得
                        const sources = srcset.split(',').map(src => src.trim().split(/\s+/));
                        if (sources.length > 0) {
                            // 最後の項目のURL部分を取得
                            fullSizeUrl = sources[sources.length - 1][0];
                        }
                    } else if (img.parentElement.tagName === 'A') {
                        // 既にAタグで囲まれている場合はそのリンク先を使う (念の為の保険)
                        fullSizeUrl = img.parentElement.getAttribute('href');
                    }

                    // 既にAタグで囲まれていない場合のみ処理を実行
                    if (img.parentElement.tagName !== 'A') {
                        // 2. 新しい <a> タグを作成
                        const link = document.createElement('a');
                        link.href = fullSizeUrl;

                        // ★重要: Modaalを適用するためのクラスを追加
                        link.classList.add('gallery__modal');

                        // ★重要: ギャラリーとしてグループ化するための属性を追加
                        link.setAttribute('data-group', groupName);

                        // 3. imgタグをaタグの中に移動
                        link.appendChild(img.cloneNode(true));

                        // 4. 元の figure の内容を a タグに置き換え
                        figure.innerHTML = '';
                        figure.appendChild(link);
                    }
                }
            });
        });

        // 5. DOM操作完了後に jQueryで Modaal を初期化
        // 注意: ModaalはjQueryプラグインなので $ を使います
        if (typeof $ !== 'undefined' && typeof $.fn.modaal !== 'undefined') {
            $('.gallery__modal').modaal({
                type: 'image',

            });
        } else {
            console.error('jQueryまたはModaalが読み込まれていません');
        }
    }
});
